export default "__VITE_ASSET__CLqGo_zj__"